import * as actionCodes from '../action-type-codes';
export {
    stepBarInit,
    stepBarReInit,
    goToNextStep,
    goToPrevStep,
    editPrevStep,
    initOnRoute,
    saveSelectionValue,
    saveSelectionValueOnModal,
    putValueOnStep,
    dismissModal,
    putValueOnStepOther,
    saveSelectedLob,
    saveVehicleLobData,
    stepbarStateReinit,
} from './stepbar.action';


export {
    saveSelectedVehicle,
    saveOpAppColumnName,
    saveVehicleData,
    setVCNumber,
    resetVCNumber,
    setSearchType,
    lobDataStateReinit,
    savePlValue,
} from './lobData.action';

export const resetAllState = () => {
    return {
        type: actionCodes.RESET_ALL_STATE
    }
}
